<div class="mobile_box">
    <div>
        <img  *ngIf="success" src="/assets/images/page_icon/success_gif.png" class="status_img" alt="">
        <img  *ngIf="!success" src="/assets/images/page_icon/failed_gif.gif" class="status_img" alt="">
    </div>
    <div *ngIf="success" class="pay_head mt-3">Payment successful !</div>
    <div *ngIf="!success" class="pay_head mt-3">Payment failed !</div>
    <div class="info_div" *ngIf="success">
        <div class="payment_info">The payment confirmation has been sent to your email address</div>
    </div>
   <div class="info_div" *ngIf="!success">
        <div class="payment_info">Your payment for tranaction ID # <span>{{referenceId}}</span> could not be processed on <span>23-01-2023 10:00:10</span></div>
        <div class="payment_info">Any Amount debited will be refunded to your account within 5-7 working business days</div>
    </div>
    <div class="trans_id">Transaction ID # <span>{{referenceId}}</span></div>
    <div *ngIf="success" class="sub_mobile_box">
        <div class="btn_payment" style="justify-content: space-between;">
            <div>
                <span><img src="/assets/images/page_icon/payment_challan.png" alt=""></span>
                <span class="btn_text">Download challan</span>
            </div>
            <div ><span ><a class="download_btn" [href]="imgPath"  download> Download</a></span></div>
        </div>
        <div><img src="/assets/images/page_icon/code.png" class="code_img" alt=""></div>
        <div class="question mt-3">How do you like our app?</div>
        <div class="btn_payment">
            <span><img src="/assets/images/page_icon/star.png" alt=""></span>
            <span class="btn_text">Rate our application</span>
        </div>
        <div class="btn_payment">
            <span><img src="/assets/images/page_icon/feedback.png" alt=""></span>
            <span class="btn_text">Leave a feedback</span>
        </div>
    </div>
</div>
